declare var $: any;

export class Project {
    static init() {
        $(".invite-button").on("click", Project.handleInviteSubmit);
    }

    static handleInviteSubmit(e: Event) {
        e.preventDefault();

        const $form = $("form.js-main-submit-form");

        $("<input>").attr("type", "hidden").attr("name", "skipInvite").attr("value", "false").appendTo($form);
        $form.submit();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/project.ts